const elemTAM = document.querySelector('.wt-Transactionmap');
window.fireOnVisible(elemTAM, async () => {
    const tamInit = new Promise(async (resolve, reject) => {
        await import('./assets/js/Transactionmap.js').then((Transactionmap) => {
            Transactionmap = Transactionmap.default;
            resolve(Transactionmap);
        });
    });

    await import('./assets/css/01_transactionmap.scss');
    await tamInit.then((Transactionmap) => {
        const tamOptions = window.TCMS.transaction;
        tamOptions.isMobile = window.TCMS.isMobile;
        tamOptions.isSmallerDesktop = document.documentElement.clientWidth < 1025;
        tamOptions.productName = window.TCMS.ck24_TCMS_product;

        const tam = new Transactionmap(elemTAM, tamOptions);
    });
});
